import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  validate (propertyPurchasedDate) {
    const message = 'The date must not be in future.';

    const purchasedDate = new UtcDate(propertyPurchasedDate);
    const todayUtc = new UtcDate();

    if (propertyPurchasedDate && purchasedDate.isAfter(todayUtc)) return message;

    return true;
  },
};
